import { render, staticRenderFns } from "./joinUs.vue?vue&type=template&id=bd4258fa&scoped=true&"
import script from "./joinUs.vue?vue&type=script&lang=js&"
export * from "./joinUs.vue?vue&type=script&lang=js&"
import style0 from "./joinUs.vue?vue&type=style&index=0&id=bd4258fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4258fa",
  null
  
)

export default component.exports